var map = {
	"./AI_Resume.png": 9542,
	"./ANNSite.jpg": 9762,
	"./AWS.svg": 4345,
	"./Azure.svg": 1663,
	"./BCC.png": 3590,
	"./BCCollege.jpg": 290,
	"./BCCollege2.jpg": 6482,
	"./BCCollege3.jpg": 4543,
	"./BCCollege4.jpg": 9908,
	"./Banking.jpg": 8584,
	"./Bash.svg": 3320,
	"./Bootstrap.svg": 2200,
	"./C++.svg": 8995,
	"./C-Sharp.svg": 7142,
	"./C.svg": 3233,
	"./CSS.svg": 995,
	"./Claude.svg": 6672,
	"./Connect4AI.png": 9516,
	"./CriterionAddon.png": 9525,
	"./Django.svg": 4767,
	"./Docker.svg": 7330,
	"./ECSite.jpg": 5185,
	"./EGX.png": 234,
	"./Express.jpg": 4761,
	"./ExpressJS.svg": 9431,
	"./FINDIT4ME.png": 4398,
	"./FSSite.png": 344,
	"./Flask.svg": 955,
	"./GCloud.svg": 3244,
	"./GameArcadePic.png": 3588,
	"./Git.svg": 9470,
	"./GitHub.svg": 8531,
	"./GoogleGemini.svg": 9998,
	"./Groq.svg": 1801,
	"./HTML5.svg": 8730,
	"./Handlebars.jpg": 9964,
	"./Haskell.svg": 2398,
	"./InboxAutomation.png": 7051,
	"./Java.svg": 1342,
	"./JavaScript.svg": 6019,
	"./Jira.svg": 5890,
	"./Json.svg": 2220,
	"./Konsing1.jpg": 3994,
	"./Konsing2.jpg": 6597,
	"./Konsing3.jpg": 4232,
	"./Konsing4.jpg": 6907,
	"./Konsing5.jpg": 5774,
	"./Konsing5b.jpg": 9734,
	"./Konsing6.jpg": 5833,
	"./Konsing7.jpg": 4108,
	"./Konsing7a.jpg": 2059,
	"./Konsing8.jpg": 5055,
	"./Konsing9.jpg": 7122,
	"./MongoDB.svg": 7820,
	"./Nextjs.svg": 2388,
	"./NodeJS.svg": 9687,
	"./OCHS.png": 2881,
	"./OCHS1.jpg": 2856,
	"./OCHS2.jpg": 1783,
	"./OCHS3.jpg": 2778,
	"./OpenAI.svg": 7400,
	"./Overhead.png": 96,
	"./PHGame.jpg": 6446,
	"./PR1.png": 2937,
	"./PSite.jpg": 9851,
	"./PostgreSQL.svg": 3144,
	"./PrismDashboard.png": 2105,
	"./Python.svg": 2580,
	"./QwikSell.png": 2636,
	"./RAG.png": 3900,
	"./React.svg": 5159,
	"./SQL.svg": 1018,
	"./SQLite.svg": 1294,
	"./Selenium.png": 8356,
	"./StartupPulse.png": 7598,
	"./Streamlit.svg": 8157,
	"./TailwindCSS.svg": 5195,
	"./TypeScript.svg": 6371,
	"./UCD.png": 858,
	"./UCDavis.jpg": 2923,
	"./UCDavis2.jpg": 4497,
	"./UCDavis3.jpg": 6452,
	"./VoiceAssistant.png": 6430,
	"./WebCrawler.jpg": 146,
	"./YappinBlog.png": 5663,
	"./sshell.jpg": 4683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9291;